var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36926 7.31805H7.39329V13.3223C7.39329 13.9315 7.88722 14.4248 8.49578 14.4248H11.5051C12.1136 14.4248 12.6076 13.9316 12.6076 13.3223V7.31805H14.6309C14.9661 7.31805 15.2675 7.11622 15.3964 6.80646C15.5239 6.49797 15.4529 6.14132 15.2161 5.90449L10.5855 1.27331C10.2621 0.950546 9.73813 0.950546 9.41402 1.27331L4.78418 5.90449C4.54731 6.14132 4.47634 6.49736 4.60458 6.80646C4.73339 7.11562 5.03406 7.31805 5.36926 7.31805Z",
    fill: "#5932EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0055 9.56848C18.4569 9.56848 18.0118 10.0137 18.0118 10.5629V14.7209C18.0118 15.9665 16.9978 16.9798 15.7521 16.9798H4.2478C3.00215 16.9798 1.98885 15.9665 1.98885 14.7209V10.5629C1.98885 10.0137 1.54306 9.56848 0.994425 9.56848C0.445136 9.56848 0 10.0137 0 10.5629V14.721C0 17.0632 1.90553 18.9688 4.2478 18.9688H15.7521C18.0944 18.9688 20 17.0632 20 14.721V10.5629C20 10.0137 19.5548 9.56848 19.0055 9.56848Z",
    fill: "#5932EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.ecdfc2250fed6fccd37c0353c4379641.svg";
export { ForwardRef as ReactComponent };